<template>
  <div class="my-warning">
    <span class="title">我的提醒</span>
    <div class="my-warning-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <p>提醒日期</p>
              <el-date-picker
                size="small"
                v-model="dates"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div class="input-li">
              <p>提醒类型</p>
              <el-select
                size="small"
                filterable
                clearable
                v-model="searchParams.type"
                placeholder="请选择提醒类型"
              >
                <el-option
                  v-for="item in warningType"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input-li">
              <p>提醒状态</p>
              <el-select
                size="small"
                filterable
                clearable
                v-model="searchParams.status"
                placeholder="请选择提醒状态"
              >
                <el-option
                  v-for="item in warningStatus"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-action">
            <el-button
              size="small"
              icon="el-icon-search"
              type="primary"
              @click="getList()"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh"
              plain
              @click="onReset()"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <el-table
        size="small"
        height="calc(100% - 150px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column
          align="center"
          prop="warningType"
          label="提醒类型"
          width="80"
        >
          <!-- <template slot-scope=" { row }">
            <span v-if="row.warningType == '警报'" style="color: #F56C6C;"> <i class="el-icon-warning"></i> {{
              row.warningType }}</span>
              <span v-else style="color: #E6A23C;"> <i class="el-icon-info"></i> {{
              row.warningType }}</span>
          </template> -->
        </el-table-column>
        <el-table-column
          align="center"
          prop="warningStatus"
          label="提醒状态"
          width="100"
        >
          <template slot-scope="{ row }">
            <span v-if="row.warningStatus == '未处理'" style="color: #f56c6c">
              <i class="el-icon-warning"></i> {{ row.warningStatus }}</span
            >
            <span v-else> {{ row.warningStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="warningDate"
          label="提醒时间"
          width="150"
        >
        </el-table-column>
        <el-table-column align="center" prop="warningContent" label="提醒内容">
        </el-table-column>
        <el-table-column
          align="center"
          prop="isUrge"
          label="是否催办"
          width="80"
        >
          <template slot-scope="{ row }">
            <span v-if="row.isUrge" style="color: #f56c6c">
              <i class="el-icon-warning"></i> 是</span
            >
            <span v-else> 否</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="urgeDate"
          label="催办时间"
          width="150"
        >
          <template slot-scope="{ row }">
            {{ row.urgeDate ? row.urgeDate : "无" }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="urgeContent" label="催办完成要求">
          <template slot-scope="{ row }">
            {{ row.urgeContent ? row.urgeContent : "无" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="120">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="lookRow(row.id)"
              >查看
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="mini"
              :disabled="row.warningStatus == '已消除'"
              type="text"
              @click="editRow(row.id)"
              >处理
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!-- <a-table bordered :resizeable="true" :rowKey="(record) => record.id" :pagination="pagination" :columns="columns"
        :picker-options="pickerOptions" :data-source="dataSource" @showSizeChange="onPage" @change="({ current, pageSize }) => {
          onPage(current, pageSize);
        }
          " size="small" :scroll="tableHeight">
        <div slot="actions" slot-scope="text, record">
          <el-button type="text" style="color: #f56c6c" size="mini">删除</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" size="mini">修改</el-button>
        </div>
      </a-table> -->
    </div>
    <editWarning ref="editWarning"></editWarning>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";
import editWarning from "./components/editWarning.vue";

export default {
  components: { editWarning },
  data() {
    return {
      dataSource: [],
      searchParams: {
        startDate: "",
        endDate: "",
        type: "",
        status: "",
      },

      dates: [],
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      warningType: [],
      warningStatus: [],
    };
  },
  computed: {},
  methods: {
    lookRow(id) {
      this.$refs.editWarning.lookDrawerOpen(id, "查看");
    },
    editRow(id) {
      this.$refs.editWarning.lookDrawerOpen(id);
    },
    getList() {
      if (this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      }

      const parames = {
        ...this.searchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.warnings.companyWarnings;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getParams() {
      const url = this.$api.warnings.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { warningType, warningStatus } = res.data.data;
          this.warningStatus = warningStatus;
          this.warningType = warningType;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.dates = [];
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      (this.searchParams = {
        startDate: "",
        endDate: "",
        type: "",
        status: "",
      }),
        this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }

  .select-searchmain1 {
    width: 100%;
    height: 70px;
    display: flex;
    padding: 5px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style> 